import MicroLoanContainer from 'containers/Microloans';

export default {
  exact: true,
  name: 'Microloan',
  protected: true,
  path: '/microloan',
  component: MicroLoanContainer,
};
